import React, { useEffect } from "react";
import { TextField, Autocomplete } from "@mui/material";

type opt = {
  value: string;
  label: string;
};
interface Props {
  label?: string;
  optionsType?: any;
  error?: boolean;
  selectedOption?: string;
  handleChange: (v: string) => void;
  getOptionLabel: (option: any) => any;
  required?: boolean;
  name?: string;
  value?: any;
  loading?: boolean;
  helperText?: any;
  disabled?: boolean;
}

export default function AsynCommonAutoCompleteField({
  label = "Add Label",
  optionsType,
  error,
  handleChange,
  getOptionLabel,
  required = false,
  name = "",
  value = "",
  loading = false,
  helperText,
  disabled,
}: Props) {
  const [detailList, setDetailList] = React.useState<any[]>([]);
  const [listRecordLoadedNumb, setListRecordLoadedNumb] = React.useState<number>(100);
  useEffect(() => {
    if (optionsType?.length) {
      setDetailList(optionsType.slice(0, listRecordLoadedNumb));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsType]);
  const searchForOption = (val: string) => {
    const newRod = [];
    if (optionsType?.length) {
      if (val === "") {
        setDetailList(optionsType.slice(0, 100));
        setListRecordLoadedNumb(100);
      } else {
        for (let i = 0; i < optionsType?.length; i++) {
          const cityName: string = optionsType[i].substring(0, val?.length);
          if (cityName.toLowerCase() === val.toLowerCase()) {
            newRod.push(optionsType[i]);
          }
        }
        setDetailList(newRod.slice(0, 1000));
      }
    }
  };
  React.useEffect(() => {
    if (!optionsType?.length) {
      setDetailList([]);
    }
  }, [optionsType]);
  return (
    <Autocomplete
      id={name}
      size="small"
      fullWidth
      disabled={disabled}
      loadingText="loading..."
      options={detailList || []}
      value={value}
      onInputChange={(_e, v) => {
        if (_e?.type === "change") {
          searchForOption(v);
        }
        if (_e?.type === "click") {
          handleChange(v);
        }
      }}
      onOpen={(_e) => {
        if (optionsType?.length) {
          setDetailList(optionsType.slice(0, listRecordLoadedNumb));
        }
      }}
      onClose={(_e) => {
        setListRecordLoadedNumb(100);
      }}
      autoComplete={true}
      ListboxProps={{
        onScroll: (event: React.SyntheticEvent) => {
          if (optionsType?.length && detailList?.length < optionsType?.length) {
            const listboxNode = event.currentTarget;
            if (
              Math.trunc(listboxNode.scrollTop + listboxNode.clientHeight) ===
              listboxNode.scrollHeight
            ) {
              setDetailList(optionsType?.slice(0, listRecordLoadedNumb + 100) || []);
              setListRecordLoadedNumb(listRecordLoadedNumb + 100);
            }
          }
        },
      }}
      getOptionLabel={(option) => getOptionLabel(option)}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          error={error}
          helperText={helperText}
          id="outlined-basic"
          label={label}
          name={name}
          variant="outlined"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />
      )}
    />
  );
}
